import { SafeNumberService } from '@common/lib/api';
import * as safeNumber from './types';

const actions = {
  // 안심번호 획득
  async [safeNumber.GET_SAFE_NUMBER](context, params) {
    console.log('GET_SAFE_NUMBER');
    console.log(params);

    const { data } = await SafeNumberService.getSafeNumber(params);

    context.commit(safeNumber.SET_SAFE_NUMBER, data);
    console.log(data);
    return data;
  },

  // 안심번호 사용
  async [safeNumber.USE_SAFE_NUMBER](context, params) {
    console.log('USE_SAFE_NUMBER');
    console.log(params);

    const { data } = await SafeNumberService.useSafeNumber(params);

    context.commit(safeNumber.SET_SAFE_NUMBER, data);
    console.log(data);
    return data;
  },
};

export default actions;
